import { render, staticRenderFns } from "./AdminApiKeys.vue?vue&type=template&id=ded87494"
import script from "./AdminApiKeys.vue?vue&type=script&lang=js"
export * from "./AdminApiKeys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports